import { gql } from 'apollo-boost';

export const BUSINESS_GROUPS_GQL = gql`
  query BusinessGroups($businessGroupIds: [ID!], $byName: String, $orderBy: BusinessGroupsOrder, $sortOrder: SearchOrder, $first: Int, $cursor: String) {
  business_groups(businessGroupIds: $businessGroupIds, byName: $byName, orderBy: $orderBy, sortOrder: $sortOrder, first: $first, after: $cursor) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      name
      created_at
      updated_at
      businesses {
        id
        name
      }
    }
  }
}
`;
